import React from 'react';

type Props = {
  className?: string;
  w?: number;
  h?: number;
  fill?: string;
  backgroundFill?: string;
};

const SberPayIcon = ({
  className,
  w = 50,
  h = 24,
  backgroundFill = '#00D800',
  fill = '#ffffff',
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 50 24"
      className={className}
    >
      <g fillRule="nonzero" fill="none">
        <path
          d="M11.976 24h26.048C44.638 24 50 18.627 50 12S44.638 0 38.024 0H11.976C5.362 0 0 5.373 0 12s5.362 12 11.976 12z"
          fill={backgroundFill}
        />
        <g fill={fill}>
          <path d="M25.066 13.275v2.69h-1.54V7.329h2.868c2.722 0 3.878.975 3.878 2.925 0 2.01-1.354 3.02-3.878 3.02h-1.328zm0-4.527v3.107h1.446c1.428 0 2.167-.468 2.167-1.64 0-1.06-.643-1.468-2.142-1.468l-1.471.001zM31.085 10.228c.405-.304 1.144-.556 2.204-.556 1.798 0 2.685.619 2.685 2.222v4.07H34.62v-1.11c-.296.715-1.046 1.209-2.033 1.209-1.243 0-1.98-.704-1.98-1.912 0-1.407 1.021-1.802 2.535-1.802h1.39v-.27c0-.876-.417-1.148-1.243-1.148-1.132 0-1.784.444-2.202 1.098l-.002-1.801zm3.446 3.559v-.5h-1.217c-.85 0-1.257.162-1.257.715 0 .469.344.765.985.765.972 0 1.428-.555 1.49-.98zM36.686 9.796h1.606l1.687 4.23 1.378-4.23h1.526l-2.46 6.822c-.544 1.48-1.096 1.813-1.91 1.813-.382 0-.803-.111-.984-.27v-1.347c.198.194.462.305.739.31.442 0 .774-.297 1.009-1.127l-2.591-6.2zM9.435 10.234v1.895l2.506 1.574 6-4.423a6.602 6.602 0 0 0-.79-1.312l-5.21 3.84-2.506-1.574z" />
          <path d="M17.003 11.855v.137a5.077 5.077 0 0 1-3.844 4.936 5.065 5.065 0 0 1-5.705-2.554A5.086 5.086 0 0 1 8.56 8.212a5.06 5.06 0 0 1 6.235-.405l1.285-.945a6.576 6.576 0 0 0-8.221-.047 6.608 6.608 0 0 0-1.862 8.024 6.583 6.583 0 0 0 7.398 3.593 6.597 6.597 0 0 0 5.026-7.62l-1.417 1.043z" />
        </g>
      </g>
    </svg>
  );
};

export default SberPayIcon;
